import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Clock, Facebook, Instagram, Twitter } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/about' },
    { name: 'Ürünlerimiz', path: '/products' },
    { name: 'Doğallık ve Kalite', path: '/quality' },
    { name: 'Lezzet Köşesi', path: '/recipes' },
    { name: 'İletişim', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-md'
    }`}>
      {/* Top Bar - Contact Info */}
      <div className="bg-[#216DB8] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-2 text-xs sm:text-sm">
            <div className="flex items-center space-x-4">
              <a href="tel:+905432026363" className="flex items-center hover:text-blue-200 transition-colors">
                <Phone className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                <span className="hidden sm:inline">0543 202 63 63</span>
              </a>
              <a href="mailto:pekala_sut_urunleri@hotmail.com" className="hidden md:flex items-center hover:text-blue-200 transition-colors">
                <Mail className="h-4 w-4 mr-1" />
                <span>pekala_sut_urunleri@hotmail.com</span>
              </a>
            </div>
            <div className="flex items-center space-x-3">
              <div className="hidden lg:flex items-center mr-4">
                <Clock className="h-4 w-4 mr-1" />
                <span>Pzt-Cuma: 08:00-18:00</span>
              </div>
              <a href="https://www.facebook.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://www.instagram.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://twitter.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center transition-transform hover:scale-105 duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_web-collaborator/artifacts/cyb27p3j_Pekala-Sut-Logo.png" 
                alt="Pekala Süt ve Süt Ürünleri" 
                className="h-16 sm:h-20 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 ${
                    isActive(item.path)
                      ? 'bg-[#216DB8] text-white shadow-md'
                      : 'text-gray-700 hover:bg-blue-50 hover:text-[#216DB8]'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <X className="h-6 w-6 text-gray-700" />
              ) : (
                <Menu className="h-6 w-6 text-gray-700" />
              )}
            </button>
          </div>

          {/* Mobile Navigation */}
          <div
            className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
              isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'
            }`}
          >
            <nav className="flex flex-col space-y-2 pt-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-semibold transition-all duration-300 ${
                    isActive(item.path)
                      ? 'bg-[#216DB8] text-white'
                      : 'text-gray-700 hover:bg-blue-50 hover:text-[#216DB8]'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
